module.exports = __webpack_public_path__ + "static/offices-content-image-1@2x-3c17b70437c2929d02ba93da158e00e9.jpg";